<template>
  <div class="row" :class="[!homePage ? 'mx-0' : '']">
    <order-id-receipt
      v-if="showOrderIdReceipt"
      v-bind:orders="selectedOrder"
      v-on:hideOrderIdReceipt="hideReceiptModal()"
    />
    <edit-order-details
      v-if="viewEditOrderDialog"
      :orders="selectedOrder"
      :viewEditOrderDialog.sync="viewEditOrderDialog"
      @reloadOffers="reloadOffers"
      @reloadOrders="getPaginatedOrders(1)"
      :isConfirmingOrder="isConfirmingOrder"
      :key="editOrderDetailsKey"
    />

    <div class="col-md-12 main-content">
      <h1 class="heading-large" v-if="!homePage" :class="{ 'first-header': !homePage }">
        <i class="fas fa-calendar-check mr-2"></i>Order History
      </h1>
      <h2 class="first-header heading-medium" v-else><i class="fas fa-calendar-check mr-2"></i>Most Recent Orders</h2>
      <div class="panel-tabs">
        <div v-if="!homePage" class="nav-tabs_parent">
          <ul class="nav nav-tabs">
            <li
              class="nav-item"
              :class="{ active: currentTab.id === tab.id }"
              v-for="(tab, key) in tabHeadings"
              :key="key"
            >
              <a class="nav-link" @click="selectTab(tab)" href="#">{{ tab.productType }} </a>
            </li>
          </ul>
        </div>
        <div class="panel-tab-content">
          <div
            class="table-container card"
            :class="{
              'border-radius-top-left-0 table-with-scrolling': !homePage,
              'px-3': $breakpoint.mdAndDown,
              '': $breakpoint.mdAndDown,
            }"
          >
            <div class="row mx-0" :class="[$breakpoint.xsOnly ? 'pb-1 pt-3' : 'py-3']">
              <div
                class="col-md-3 col-xs-12 d-flex align-items-center"
                :class="[
                  {
                    'px-0': $breakpoint.mdAndDown,
                    'mb-3': $breakpoint.xsOnly,
                  },
                  homePage ? 'col-sm-6' : 'col-sm-3',
                ]"
              >
                <h5 v-if="!homePage" class="heading-small">
                  <i class="fas fa-inbox mr-2"></i>Showing
                  <span>{{ numberOfOrders }}</span>
                  order<span v-if="numberOfOrders > 1">s </span>
                </h5>
              </div>
              <div class="col-md-9 col-sm-9 col-xs-12" :class="{ 'px-0': $breakpoint.mdAndDown }">
                <span class="panel-controller d-flex justify-content-end">
                  <vc-date-picker
                    v-if="!homePage"
                    mode="range"
                    v-model="selectedDate"
                    class="vc-date-picker ml-2 mr-1 datePicker"
                    :max-date="new Date()"
                    :columns="$breakpoint.mdAndDown ? 1 : 2"
                    :key="calenderKey"
                    :update-on-input="false"
                    :input-props="{
                      placeholder: 'dd/mm/yyyy - dd/mm/yyyy',
                      readonly: true,
                    }"
                    :popover="{
                      placement: 'bottom',
                    }"
                  >
                  </vc-date-picker>
                  <el-tooltip content="Resets date range to the last 6 months" placement="top">
                    <button
                      class="btn btn-actionable ml-1 px-2"
                      type="button"
                      v-if="!homePage"
                      :disabled="isDefaultDateRange"
                      @click="resetDateRange"
                    >
                      Reset Date Range
                    </button>
                  </el-tooltip>
                  <div v-if="!homePage && !$breakpoint.smAndDown" class="dropdown operation download mr-4">
                    <el-tooltip
                      class="pr-1"
                      content="You can only download orders for up to 6 months period at a time"
                      placement="top"
                      v-if="downloadDisabled"
                    >
                      <button
                        class="btn btn-actionable dropdown-toggle ml-1"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        disabled
                      >
                        <i class="fas fa-download"></i> &nbsp; Download
                        <span v-if="purchasesSelected.length > 0">({{ purchasesSelected.length }}) rows</span>
                      </button>
                    </el-tooltip>
                    <button
                      v-else
                      class="btn btn-actionable dropdown-toggle ml-1"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      :disabled="isDownloading"
                    >
                      <i :class="isDownloading ? 'fas fa-spinner fa-spin' : 'fas fa-download'"></i> &nbsp;
                      {{ isDownloading ? "Preparing..." : "Download" }}
                      <span v-if="purchasesSelected.length > 0 && !isDownloading"
                        >({{ purchasesSelected.length }}) rows</span
                      >
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item d-flex justify-content-between align-items-end" @click="selectCSV">
                        <strong>.CSV</strong>
                        <i class="fas fa-file-csv fa-2x"></i>
                      </a>
                      <a class="dropdown-item d-flex justify-content-between align-items-end" @click="selectXlsx">
                        <strong>.XLSX</strong>
                        <i class="far fa-file-excel fa-2x"></i>
                      </a>
                    </div>
                  </div>
                </span>
              </div>
            </div>
            <div v-if="showDownloadHint" class="text-muted text-center mt-1 mx-4">
              <i class="fas fa-info-circle mr-1"></i>Large date ranges may take up to a minute to prepare.
            </div>
            <div
              v-if="downloadError"
              class="alert alert-t_red alert-dismissible fade show mt-2 mx-4 text-center"
              role="alert"
            >
              <i class="fas fa-exclamation-circle mr-2"></i>{{ downloadError }}
              <button type="button" class="close" @click="downloadError = ''" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <template>
              <div class="group-rounded-box my-3 mx-4">
                <span class="title">Filters</span>

                <!-- ROW -->
                <div class="row">
                  <!-- CUSTOMER SELECTION -->
                  <div v-if="getAccountType === 'seller'" class="col-md-3 mt-2">
                    <label for="selectCustomer">Customers</label>
                    <div class="position-relative">
                      <el-select
                        v-model="selectedCustomers"
                        value-key="id"
                        placeholder="Search customer(s)"
                        multiple
                        filterable
                        clearable
                      >
                        <el-option
                          v-for="item in availableCustomers"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                        <!-- User search resulting in no match -->
                        <template #empty>No matching customer</template>
                      </el-select>
                    </div>
                  </div>

                  <!-- TERMINAL SELECTION -->
                  <div class="col-md-3 mt-2">
                    <label for="selectTerminal">Terminals</label>
                    <div class="position-relative">
                      <el-select
                        v-model="selectedTerminals"
                        multiple
                        value-key="_id"
                        placeholder="Search terminal(s)"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in getTerminalChanges"
                          :key="item._id"
                          :label="item.name"
                          :value="item._id"
                        ></el-option>
                        <!-- User search resulting in no match -->
                        <template #empty>No matching terminal</template>
                      </el-select>
                    </div>
                  </div>

                  <!-- PRODUCT SELECTION -->
                  <div class="col-md-3 mt-2">
                    <label for="selectProduct">Products</label>
                    <div class="position-relative">
                      <el-select
                        class="el-olf"
                        v-model="selectedProducts"
                        value-key="_id"
                        multiple
                        filterable
                        collapse-tags
                        clearable
                        placeholder="Search product(s)"
                      >
                        <el-option
                          v-for="item in availableProducts"
                          :key="item._id"
                          :label="item.name"
                          :value="item._id"
                        ></el-option>
                        <!-- User search resulting in no match -->
                        <template #empty>No matching product</template>
                      </el-select>
                    </div>
                  </div>
                  <!-- NETWORK SELECTION -->
                  <div class="col-md-3 mt-2">
                    <label for="selectNetwork">Networks</label>
                    <div class="position-relative">
                      <el-select
                        class="el-olf"
                        v-model="selectedNetworks"
                        value-key="_id"
                        placeholder="Search network(s)"
                        multiple
                        filterable
                        collapse-tags
                        clearable
                      >
                        <el-option
                          v-for="item in networks"
                          :key="item._id"
                          :label="item.name"
                          :value="item._id"
                        ></el-option>
                        <!-- User search resulting in no match -->
                        <template #empty>No matching network</template>
                      </el-select>
                    </div>
                  </div>
                  <!-- ORDER ID SEARCH -->
                  <div class="col-md-3 mt-2">
                    <label for="searchOrderId">Order ID</label>
                    <div class="position-relative">
                      <el-input
                        v-model="orderIdSearch"
                        placeholder="Search order ID"
                        @input="orderIdSearchDebounce"
                        maxlength="7"
                      ></el-input>
                    </div>
                  </div>
                  <!-- RELEASE NUMBER SEARCH -->
                  <div v-if="isUpdateOrderNumbersEnabled" class="col-md-3 mt-2">
                    <label for="searchReleaseNumber">Release Number</label>
                    <div class="position-relative">
                      <el-input
                        v-model="releaseNumberSearch"
                        placeholder="Search release number"
                        @input="releaseNumberSearchDebounce"
                      ></el-input>
                    </div>
                  </div>
                  <!-- MOVEMENT NUMBER SEARCH -->
                  <div v-if="isUpdateOrderNumbersEnabled" class="col-md-3 mt-2">
                    <label for="searchMovementNumber">Movement Number</label>
                    <div class="position-relative">
                      <el-input
                        v-model="movementNumberSearch"
                        placeholder="Search movement number"
                        @input="movementNumberSearchDebounce"
                      ></el-input>
                    </div>
                  </div>
                  <!-- ROW -->
                </div>
              </div>
            </template>
            <div v-if="!ordersHaveLoaded" class="w-100 alert tables-alert-custom-message-notify mt-3 text-center">
              <i class="fas fa-info-circle mr-2"></i>Loading ...
            </div>
            <div
              v-else-if="ordersHaveLoaded === 'Success' && paginatedPurchasesData.length == 0"
              class="w-100 alert tables-alert-custom-message-notify mt-3 text-center"
            >
              <i class="fas fa-info-circle mr-2"></i>No Orders
            </div>
            <div v-else-if="ordersHaveLoaded === 'Failed'" class="w-100 alert alert-t_red mt-3 text-center">
              <i class="fas fa-info-circle mr-2"></i>Connection Error
            </div>
            <table
              v-else-if="paginatedPurchasesData.length > 0 && ordersHaveLoaded === 'Success'"
              class="table responsive-table"
              id="purchase-table"
            >
              <thead v-if="paginatedPurchasesData.length !== 0">
                <tr>
                  <th
                    v-for="(heading, key) in getColumnTitles"
                    :key="key"
                    :width="heading.width"
                    :class="heading.thClass"
                    class="text-nowrap"
                  >
                    <input v-if="key === 0 && !homePage" type="checkbox" v-model="isAllSelected" />
                    <span v-else>
                      {{ heading.title }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody :class="[$breakpoint.mdAndDown ? 'h-100' : 'h-100-370px']">
                <template v-for="(filledRow, key) in purchases">
                  <tr
                    :class="{ 'pb-1': $breakpoint.mdAndDown }"
                    :key="key"
                    @click="goToOrderHistory($event, filledRow)"
                  >
                    <td width="3%" v-if="!homePage && !$breakpoint.mdAndDown">
                      <input
                        type="checkbox"
                        v-model="purchasesSelected"
                        :value="filledRow._id"
                        v-if="!filledRow.orderCancelled"
                      />
                      <el-tooltip
                        class="pr-1"
                        content="This item has been removed from the order"
                        placement="top"
                        v-if="!filledRow.orderCancelled && filledRow.lineItemCancelled"
                      >
                        <i class="fas fa-flag pr-1 text-t_red"> </i>
                      </el-tooltip>
                      <el-tooltip
                        class="pr-1"
                        content="This order has been cancelled"
                        placement="top"
                        v-if="filledRow.orderCancelled"
                      >
                        <i class="fas fa-flag pr-1 text-t_red"> </i>
                      </el-tooltip>
                    </td>
                    <td label="Order Id" width="6%" height="40px;" class="td-actions" v-if="!homePage">
                      <button
                        v-if="!homePage"
                        class="btn btn-link order-history-btn-link"
                        @click="showOrderIdReceiptModal(filledRow)"
                      >
                        <span>{{ filledRow.orderId }}</span>
                      </button>
                    </td>
                    <td label="Date" width="7%">
                      <span>{{ filledRow.date }}</span>
                    </td>
                    <td label="Contract Number" width="7%" v-if="!homePage && isUpdateOrderNumbersEnabled">
                      <span>{{ filledRow.contractNumber ? filledRow.contractNumber : "-" }}</span>
                    </td>
                    <td label="Release Number" width="7%" v-if="!homePage && isUpdateOrderNumbersEnabled">
                      <span>{{ filledRow.releaseNumber ? filledRow.releaseNumber : "-" }}</span>
                    </td>
                    <td label="Movement Number" width="7%" v-if="!homePage && isUpdateOrderNumbersEnabled">
                      <span>{{ filledRow.movementNumber ? filledRow.movementNumber : "-" }}</span>
                    </td>
                    <td label="Account No." width="7%" v-if="!homePage && currentTab.id === BUNKERING">
                      <span>{{ filledRow.bunkeringAccountNumber }}</span>
                    </td>
                    <td label="Seller" width="7%">
                      <span>{{ filledRow.account }}</span>
                    </td>
                    <td label="Product" width="7%" v-if="currentTab.id !== BUNKERING">
                      <span>{{ filledRow.fuel }}</span>
                    </td>
                    <td v-if="currentTab.id !== BUNKERING" label="Terminal" width="7%">
                      <span>{{ filledRow.terminal }}</span>
                    </td>
                    <td v-else label="Network" width="7%">
                      <span>{{ filledRow.terminal }}</span>
                    </td>
                    <td label="Vol/L" width="7%">
                      <span>{{ filledRow.quantity }}</span>
                    </td>
                    <td label="Delivery Location" width="7%" v-if="!homePage && currentTab.id === DELIVERED_IN">
                      <span>{{ filledRow.delivery_location }}</span>
                    </td>
                    <td
                      label="Lifting Period"
                      width="7%"
                      v-if="!homePage && currentTab.id !== BUNKERING && currentTab.id !== DELIVERED_IN"
                    >
                      <span>{{ filledRow | liftingperiodformat }}</span>
                    </td>
                    <td label="Delivery Date" width="7%" v-if="!homePage && currentTab.id === DELIVERED_IN">
                      <span>{{ filledRow.deliveryDate }}</span>
                    </td>
                    <td label="Payment Terms" width="7%" v-if="!homePage && currentTab.id !== ALL">
                      <span>{{ filledRow.credit_days }}</span>
                    </td>
                    <td
                      label="Type"
                      width="4%"
                      v-if="!homePage && (currentTab.id === EX_RACK || currentTab.id === BUNKERING)"
                    >
                      <span class="text-nowrap">{{ filledRow.offer_type }}</span>
                    </td>
                    <td label="Pricing Method" width="7%" v-if="!homePage && currentTab.id === CONTRACT">
                      <span>{{ filledRow.pricingMethod }}</span>
                    </td>
                    <td label="Price (ppl)" width="7%">
                      <span class="text-nowrap"> {{ filledRow.price }} </span>
                    </td>
                    <td label="Total (£)" class="text-right" width="7%">
                      <span class="d-flex flex-row-reverse text-nowrap">
                        <span>
                          {{ filledRow.offerTotal }}
                        </span>
                        <el-tooltip
                          class="pr-1"
                          content="Please note that this order has been edited by the Seller."
                          placement="top"
                          v-if="filledRow.edited && !filledRow.orderCancelled"
                        >
                          <i
                            class="fas fa-info-circle mr-1 tooltip-icons-color"
                            v-if="filledRow.edited && !filledRow.orderCancelled"
                          ></i>
                        </el-tooltip>
                      </span>
                    </td>
                    <td
                      label="Status"
                      class="text-right text-nowrap"
                      :class="`text-${calculateOrderDisplay(filledRow).textColor}`"
                      width="5%"
                      v-if="!homePage && (isEditOrdersEnabled || getAccountType === 'buyer')"
                    >
                      {{ calculateOrderDisplay(filledRow).text }}
                    </td>
                    <td label="Actions" class="text-right" width="6%" v-if="!homePage && isEditOrdersEnabled">
                      <span>
                        <el-select id="input" :value="orderAction" placeholder="Action">
                          <el-option
                            v-for="item in calculateOrderDisplay(filledRow).showEditOptionOnly ||
                            filledRow.orderCancelled
                              ? actionOptionsEditOnly
                              : actionOptionsAll"
                            :key="item.text"
                            :label="item.text"
                            :value="item.text"
                          >
                            <div :class="item.color" @click="enactActionSelected(item.value, filledRow)">
                              {{ item.text }}
                            </div>
                          </el-option>
                        </el-select>
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="!homePage" class="mt-3">
          <paginate
            class="float-left"
            v-model="pageNumber"
            :page-count="maxNumberOfPages"
            :click-handler="getPaginatedOrders"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination bg-white'"
            :page-class="'pagination-item'"
            :page-link-class="'border-right-0'"
            :prev-class="'pagination-item pagination-prev rounded-sm rounded-sm-left'"
            :next-class="'pagination-item pagination-next rounded-sm rounded-sm-right'"
            :active-class="'active'"
            :disabled-class="'btn-disabled bg-disabled'"
          >
          </paginate>
          <div class="float-right pageLimits">
            <fieldset class="form-group mt-0" id="__BVID__99">
              <label class="mt-2 mr-2 d-inline-block float-left">Show</label>
              <div tabindex="-1" role="group" class="float-right">
                <div role="radiogroup" tabindex="-1" class="btn-group-toggle btn-group">
                  <label
                    class="btn"
                    :class="{
                      'btn-neutral text-white': rows == 25,
                      'btn-outline-t_greyish-blue text-platform-default bg-white': rows != 25,
                    }"
                  >
                    <input
                      type="radio"
                      name="limit-buttons"
                      autocomplete="off"
                      class=""
                      v-model="limit"
                      value="25"
                      @change="getPaginatedOrders(1)"
                    />
                    <span>25</span>
                  </label>
                  <label
                    class="btn"
                    :class="{
                      'btn-neutral text-white': rows == 50,
                      'btn-outline-t_greyish-blue text-platform-default bg-white': rows != 50,
                    }"
                  >
                    <input
                      type="radio"
                      name="limit-buttons"
                      autocomplete="off"
                      class=""
                      v-model="limit"
                      value="50"
                      @change="getPaginatedOrders(1)"
                    />
                    <span>50</span>
                  </label>
                  <label
                    class="btn"
                    :class="{
                      'btn-neutral text-white': rows == 100,
                      'btn-outline-t_greyish-blue text-platform-default bg-white': rows != 100,
                    }"
                  >
                    <input
                      type="radio"
                      name="limit-buttons"
                      autocomplete="off"
                      class=""
                      v-model="limit"
                      value="100"
                      @change="getPaginatedOrders(1)"
                    />
                    <span>100</span>
                  </label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import papa from "papaparse";
import ExcelJS from "exceljs-hardened";
import moment from "moment";
import { saveAs } from "file-saver";
import { debounce } from "lodash";
import differenceInMonths from "date-fns/differenceInMonths";

import { getOrderStatusDisplay } from "@/util/orderBuilder";
import OrderIdReceipt from "@/modals/OrderIdReceipt.vue";
import EditOrderDetails from "@/modals/EditOrderDetails.vue";
import breakpoint from "@/mixins/index";
import { getPaginatedOrders } from "@/api/orders";
import { organiseOrders } from "../../util/orderBuilder";
import { downloadOrders } from "../../api/orders";
import { yearMonthDayDateFormat } from "../../util/filters";

const fileName = "OLF_Orders";

const ALL = "ALL";
const EX_RACK = "EX-RACK";
const BUNKERING = "BUNKERING";
const CONTRACT = "CONTRACT";
const DELIVERED_IN = "DELIVERED_IN";
const HOME = "HOME";

export default {
  components: {
    OrderIdReceipt,
    EditOrderDetails,
  },
  mixins: [breakpoint],
  data: function () {
    return {
      isConfirmingOrder: false,
      editOrderDetailsKey: 0,
      viewEditOrderDialog: false,
      selectedNetworks: [],
      selectedCustomers: [],
      selectedTerminals: [],
      selectedProducts: [],
      orderIdSearch: "",
      orderIdSearchDebounced: "",
      releaseNumberSearch: "",
      releaseNumberSearchDebounced: "",
      movementNumberSearch: "",
      movementNumberSearchDebounced: "",
      actionOptionsAll: [
        { color: "text-t_green", text: "Confirm", value: "CONFIRM" },
        { color: "text-t_blue", text: "Edit", value: "EDIT" },
      ],
      actionOptionsEditOnly: [{ color: "text-t_blue", text: "Edit", value: "EDIT" }],
      orderAction: null,
      ALL,
      EX_RACK,
      BUNKERING,
      CONTRACT,
      DELIVERED_IN,
      HOME,
      showOrderIdReceipt: false,
      selectedOrder: "",
      selectedRow: -1,
      start_date: new Date(new Date().setMonth(new Date().getMonth() - 6)),
      end_date: new Date(),
      selectedDate: { start: new Date(new Date().setMonth(new Date().getMonth() - 6)), end: new Date() },
      calenderKey: 0,
      newest: "",
      errorStartDate: false,
      showDownloadOptions: false,
      isDownloading: false,
      downloadError: "",
      showDownloadHint: false,
      purchasesSelected: [],
      activeSortDirection: "asc",
      activeSortColumn: "date",
      filteredOrdersList: [],
      homePage: false,
      maxNumberOfPages: 0,
      paginatedPurchasesData: [],
      pageLimit: 0,
      pageNumber: 1,
      numberOfOrders: 0,
      ordersHaveLoaded: null,
      rows: 25,
      columnTitles: [
        {
          title: "",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT],
          width: "3%",
        },
        {
          title: "Order ID",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT],
          sort_icon: "alpha",
          sortKey: "order_id",
          width: "6%",
        },
        {
          title: "Date",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT, HOME],
          sort_icon: "numeric",
          sortKey: "date",
          width: "7%",
        },
        {
          title: "Contract No.",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT],
          sort_icon: "alpha",
          sortKey: "contractNumber",
          width: "7%",
        },
        {
          title: "Release No.",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT],
          sort_icon: "alpha",
          sortKey: "releaseNumber",
          width: "7%",
        },
        {
          title: "Movement No.",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT],
          sort_icon: "alpha",
          sortKey: "movementNumber",
          width: "7%",
        },
        {
          title: "Order Ref",
          used_by: [],
          sort_icon: "alpha",
          sortKey: "order_reference",
          width: "7%",
        },
        {
          title: "Account No.",
          used_by: [BUNKERING],
          sort_icon: "alpha",
          sortKey: "order_id",
          width: "7%",
        },
        {
          title: "Seller",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT, HOME],
          sort_icon: "alpha",
          sortKey: "counterpart",
          width: "7%",
        },
        {
          title: "Product",
          used_by: [ALL, EX_RACK, DELIVERED_IN, CONTRACT, HOME],
          sort_icon: "alpha",
          sortKey: "fuel",
          width: "7%",
        },
        {
          title: "Terminal",
          used_by: [ALL, EX_RACK, DELIVERED_IN, CONTRACT, HOME],
          sort_icon: "alpha",
          sortKey: "terminal",
          width: "7%",
        },
        {
          title: "Network",
          used_by: [BUNKERING],
          sort_icon: "alpha",
          sortKey: "network",
          width: "7%",
        },
        {
          title: "Vol/L",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT, HOME],
          sort_icon: "numeric",
          sortKey: "volume",
          width: "7%",
        },
        {
          title: "Bio Pricing",
          used_by: [],
          sort_icon: "alpha",
          sortKey: "bio",
          width: "7%",
        },
        {
          title: "Delivery Location",
          used_by: [DELIVERED_IN],
          sort_icon: "alpha",
          sortKey: "delivery_location",
          width: "7%",
        },
        {
          title: "Measurement",
          used_by: [],
          sort_icon: "alpha",
          sortKey: "measurement",
          width: "7%",
        },
        {
          title: "Lifting Period",
          used_by: [ALL, EX_RACK, CONTRACT],
          sort_icon: "numeric",
          sortKey: "liftingPeriod",
          width: "7%",
        },
        {
          title: "Delivery Date",
          used_by: [DELIVERED_IN],
          sort_icon: "numeric",
          sortKey: "deliveryDate",
          width: "7%",
        },
        {
          title: "Payment Terms",
          used_by: [EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT],
          sort_icon: "numeric",
          sortKey: "credit_days",
          width: "7%",
        },
        {
          title: "Type",
          used_by: [EX_RACK, BUNKERING],
          sort_icon: "alpha",
          sortKey: "offer_type",
          width: "3%",
        },
        {
          title: "Pricing Method",
          used_by: [CONTRACT],
          sort_icon: "alpha",
          sortKey: "pricingMethod",
          width: "7%",
        },
        {
          title: "Price (ppl)",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT, HOME],
          sort_icon: "numeric",
          sortKey: "price",
          width: "7%",
        },
        {
          title: "Total (£)",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT, HOME],
          sort_icon: "numeric",
          sortKey: "total_cost",
          thClass: "text-right",
          width: "7%",
        },
        {
          title: "Status",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT],
          sort_icon: "alpha",
          thClass: "text-right",
          sortKey: "status",
          width: "5%",
        },
      ],
      tabs: [
        {
          id: ALL,
          productType: "All",
          linkToProduct: "/OrderHistory/all",
          queryType: "ALL",
        },
        {
          id: EX_RACK,
          productType: "Ex-Rack",
          linkToProduct: "/OrderHistory/ex-rack",
          queryType: "EX",
        },
        {
          id: BUNKERING,
          productType: "Bunkering",
          linkToProduct: "/OrderHistory/bunkering",
          queryType: "BUNK",
        },
        {
          id: CONTRACT,
          productType: "Contract",
          linkToProduct: "/OrderHistory/contract",
          queryType: "CON",
        },
        {
          id: DELIVERED_IN,
          productType: "Delivered In",
          linkToProduct: "/OrderHistory/deliveredIn",
          queryType: "DIN",
        },
        {
          id: HOME,
          productType: "Dashboard",
          linkToProduct: "/",
          queryType: "ALL",
        },
      ],
      currentTab: {},
      numberOfOrdersDisplayed: 0,
    };
  },
  created() {
    // Non-reactive flags (intentionally not in data() to avoid triggering watchers)
    this._switchingTab = false;
    this._initialised = false;
    this._downloadHintTimer = null;

    this.currentTab = this.tabs[0];
    if (this.$route.name === "PurchaseHistory") {
      this.homePage = false;
      const selectedTab = this.tabs.find(({ linkToProduct }) => linkToProduct === this.$router.history.current);
      this.switchTab(selectedTab ? selectedTab : this.tabs[0]);
    } else {
      this.homePage = true;
      this.switchTab(this.tabs.find(({ id }) => id === HOME));
    }
    this.changeColumnNameDependingOnUserType();
    this.addColumnNamesIfManagerOrdersEnabled();
    this.allowUpdateOrderList(false);
  },
  mounted() {
    /* Update Order Notifications as page is loaded */
    for (let i = 0; this.notificationList.length > i; i++) {
      if (this.notificationList[i].type_id === "ORDER" && this.notificationList[i].viewed === null)
        this.updateNotification(this.notificationList[i].group_id);
    }
  },
  beforeDestroy() {
    clearTimeout(this._downloadHintTimer);
  },
  methods: {
    ...mapActions("notifications", ["updateNotification"]),
    ...mapActions("offers", ["getLiveContractsList"]),
    ...mapActions("orders", ["allowUpdateOrderList"]),
    enactActionSelected(actionSelected, order) {
      const orders = this.purchases.filter(({ _id }) => order._id === _id);
      this.selectedOrder = orders;
      switch (actionSelected) {
        case "CONFIRM":
          this.isConfirmingOrder = true;
          break;
        default:
          break;
      }
      this.viewEditOrderDialog = true;
    },
    getPaginatedOrders: async function (pageNumber, force) {
      if (!force && !this._initialised) {
        return;
      }
      if (pageNumber && pageNumber > 0) {
        this.pageNumber = pageNumber;
      }
      this.purchasesSelected = [];
      try {
        const { metadata, orders } = await getPaginatedOrders(this.createOrdersPayload());
        this.maxNumberOfPages = metadata.pageCount;
        this.paginatedPurchasesData = organiseOrders(
          orders,
          this.getAccountType,
          this.$store.getters["metadata/networks"]
        );
        this.numberOfOrders = orders.length;
        this.ordersHaveLoaded = "Success";
      } catch (ex) {
        console.log(ex);
        this.ordersHaveLoaded = "Failed";
      }
    },
    createOrdersPayload() {
      const payload = {
        page: this.pageNumber,
        limit: this.homePage ? 5 : this.rows, // only display 5 most recent orders on dashboard
        query_type: this.currentTab.queryType,
      };
      if (this.selectedTerminals && this.selectedTerminals.length) {
        payload.terminals = this.selectedTerminals;
      }
      if (this.selectedProducts && this.selectedProducts.length) {
        payload.products = this.selectedProducts;
      }
      if (this.selectedNetworks && this.selectedNetworks.length) {
        payload.networks = this.selectedNetworks;
      }
      if (this.selectedCustomers && this.selectedCustomers.length) {
        payload.customers = this.selectedCustomers;
      }
      if (this.orderIdSearchDebounced) {
        payload.orderIdSearch = this.orderIdSearchDebounced;
      }
      if (this.releaseNumberSearchDebounced) {
        payload.releaseNumberSearch = this.releaseNumberSearchDebounced;
      }
      if (this.movementNumberSearchDebounced) {
        payload.movementNumberSearch = this.movementNumberSearchDebounced;
      }
      if (this.start_date && this.end_date) {
        payload.end_date = moment(this.end_date).endOf("day").toISOString();
        payload.start_date = moment(this.start_date).startOf("day").toISOString();
      }
      return payload;
    },
    goToOrderHistory: function (event, order) {
      if (this.$breakpoint.mdAndDown) {
        this.showOrderIdReceiptModal(order);
      } else {
        if (event.target.localName !== "button" && this.homePage === true) {
          this.$router.push({ name: "PurchaseHistory" });
        }
      }
    },
    calculateOrderDisplay(order) {
      return getOrderStatusDisplay(order, "purchaseHistory");
    },
    changeColumnNameDependingOnUserType: function () {
      const columnHeading = this.getAccountType === "buyer" ? "Seller" : "Buyer";
      this.columnTitles.find((header) => header.sortKey === "counterpart").title = columnHeading;
    },
    addColumnNamesIfManagerOrdersEnabled: function () {
      if (this.isEditOrdersEnabled) {
        this.columnTitles.push({
          title: "Actions",
          used_by: [ALL, EX_RACK, DELIVERED_IN, BUNKERING, CONTRACT],
          sort_icon: "alpha",
          sortKey: "action",
          width: "6%",
        });
      }
    },
    selectTab: async function (tab) {
      event.preventDefault();
      this.$router.push(tab.linkToProduct);
      await this.switchTab(tab);
    },
    async selectCSV() {
      this.isDownloading = true;
      this.downloadError = "";
      this.showDownloadHint = false;
      this._downloadHintTimer = setTimeout(() => {
        this.showDownloadHint = true;
      }, 5000);
      try {
        const csvFile = await downloadOrders(this.createOrdersPayload(), this.purchasesSelected);
        const csv = new Blob([csvFile.data], { type: "text/csv; charset=utf-8" });
        saveAs(csv, this.downloadFileName("csv"));
      } catch (err) {
        this.downloadError = "Download failed. Please try again or select a shorter date range.";
      } finally {
        clearTimeout(this._downloadHintTimer);
        this.showDownloadHint = false;
        this.isDownloading = false;
      }
    },
    downloadFileName(fileType) {
      if (fileType) {
        return `${fileName}_${yearMonthDayDateFormat()}.${fileType}`;
      } else {
        return `${fileName}_${yearMonthDayDateFormat()}`;
      }
    },
    async selectXlsx() {
      this.isDownloading = true;
      this.downloadError = "";
      this.showDownloadHint = false;
      this._downloadHintTimer = setTimeout(() => {
        this.showDownloadHint = true;
      }, 5000);
      try {
        const nameReference = this.downloadFileName();
        const csvFile = await downloadOrders(this.createOrdersPayload(), this.purchasesSelected);
        const csvText = await csvFile.data.text();
        const unparsedData = papa.parse(csvText, { header: true });
        const workbook = new ExcelJS.Workbook();
        workbook.creator = this.$store.getters["accounts/accountDetails"].name;
        workbook.title = nameReference;
        workbook.subject = nameReference;
        const worksheet = workbook.addWorksheet(nameReference);
        const headers = unparsedData.meta.fields;
        worksheet.columns = headers.map((key) => ({ header: key, key }));
        unparsedData.data.forEach((row) => {
          worksheet.addRow(row);
        });
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: "application/octet-stream" }), this.downloadFileName("xlsx"));
      } catch (err) {
        this.downloadError = "Download failed. Please try again or select a shorter date range.";
      } finally {
        clearTimeout(this._downloadHintTimer);
        this.showDownloadHint = false;
        this.isDownloading = false;
      }
    },
    switchTab: async function (tab) {
      this._switchingTab = true;
      this.currentTab = tab;
      this.pageNumber = 1;
      this.rows = 25;
      await this.getPaginatedOrders(undefined, true);
      this._initialised = true;
      // Reset after Vue flushes all pending watchers triggered by the currentTab change
      this.$nextTick(() => {
        this._switchingTab = false;
      });
    },
    showOrderIdReceiptModal(order) {
      const multipleOrderIds = order.orderId.substring(0, 7);
      const result = this.purchases.filter((currentOrder) => {
        if (currentOrder.orderId.includes(multipleOrderIds)) return currentOrder;
      });

      this.selectedOrder = result;
      this.showOrderIdReceipt = true;
    },
    hideReceiptModal() {
      this.showOrderIdReceipt = false;
    },
    async reloadOffers(order) {
      this.getPaginatedOrders().then(() => {
        const orders = this.purchases.filter(({ _id }) => order._id === _id);
        this.selectedOrder = orders;
        this.editOrderDetailsKey += 1;
      });
    },
    orderIdSearchDebounce: debounce(function (val) {
      this.orderIdSearchDebounced = val;
    }, 600),
    releaseNumberSearchDebounce: debounce(function (val) {
      this.releaseNumberSearchDebounced = val;
    }, 600),
    movementNumberSearchDebounce: debounce(function (val) {
      this.movementNumberSearchDebounced = val;
    }, 600),
    resetDateRange() {
      this.selectedDate = { start: new Date(new Date().setMonth(new Date().getMonth() - 6)), end: new Date() };
    },
  },
  computed: {
    ...mapGetters("accounts", ["customerList"]),
    ...mapGetters("terminals", ["getTerminalChanges"]),
    ...mapGetters("login", ["getAccountType"]),
    ...mapGetters("fuelsType", ["getSpotFuels"]),
    ...mapGetters("metadata", ["networks"]),
    ...mapGetters("notifications", ["notificationList"]),
    ...mapGetters("offers", ["getLiveContracts", "getHasExistingContracts"]),
    ...mapGetters("orders", ["isOrderListUpdateAllowedGetter", "displayFilteredOrders"]),
    isEditOrdersEnabled() {
      return this.$store.getters["login/isEditOrdersEnabled"] && this.getAccountType == "seller";
    },
    isUpdateOrderNumbersEnabled() {
      if (this.getAccountType === "buyer") {
        return true;
      }
      return this.$store.getters["login/isUpdateOrderNumbersEnabled"];
    },
    getColumnTitles() {
      let columns = this.columnTitles.filter(
        (title) =>
          title.used_by.includes(this.currentTab.id) && !(title.sortKey == "bio" && this.getAccountType == "buyer")
      );
      if (!this.isUpdateOrderNumbersEnabled) {
        columns = columns.filter(
          (item) => !["releaseNumber", "contractNumber", "movementNumber"].includes(item.sortKey)
        );
      }
      if (!this.$store.getters["login/isEditOrdersEnabled"] && this.getAccountType == "seller") {
        columns = columns.filter((item) => item.sortKey !== "status");
      }
      return columns;
    },
    tabHeadings: {
      get: function () {
        return this.tabs.filter(({ id }) => id !== HOME);
      },
    },
    limit: {
      set: function (limit) {
        this.rows = limit;
      },
      get: function () {
        return this.rows;
      },
    },
    availableProducts: {
      get: function () {
        return this.getSpotFuels.toSorted(({ name: name1 }, { name: name2 }) => String(name1).localeCompare(name2));
      },
    },
    availableCustomers: {
      get: function () {
        return this.customerList.toSorted(({ name: name1 }, { name: name2 }) => String(name1).localeCompare(name2));
      },
    },
    isAllSelected: {
      set: function (currentStatus) {
        if (currentStatus == true) {
          const orderListReference = this.displayFilteredOrders ? this.filteredOrdersList : this.purchases;
          orderListReference.forEach((order, key) => {
            // If this order ID has not been added, let's add it to the list
            if (!this.purchasesSelected.includes(order._id)) this.purchasesSelected.splice(key, key + 1, order._id);
          });
        } else {
          this.purchasesSelected = [];
        }
      },
      get: function () {
        const orderListReference = this.displayFilteredOrders ? this.filteredOrdersList : this.purchases;
        // We only care about the number of unique order IDs in the list, hence we need a map, otherwise a DIN order with multiple products will skew the evaluation
        return this.purchasesSelected.length == [...new Set(orderListReference.map((o) => o._id))].length;
      },
    },
    purchases: {
      get: function () {
        return this.paginatedPurchasesData;
      },
    },
    filters: {
      get: function () {
        return {
          selectedTerminals: this.selectedTerminals,
          selectedNetworks: this.selectedNetworks,
          selectedProducts: this.selectedProducts,
          selectedCustomers: this.selectedCustomers,
          orderIdSearch: this.orderIdSearchDebounced,
          releaseNumberSearch: this.releaseNumberSearchDebounced,
          movementNumberSearch: this.movementNumberSearchDebounced,
          start_date: this.start_date,
          end_date: this.end_date,
        };
      },
    },
    downloadDisabled() {
      return !this.selectedDate || differenceInMonths(this.selectedDate.end, this.selectedDate.start) > 6;
    },
    isDefaultDateRange() {
      if (!this.selectedDate) {
        return false;
      }
      const sixMonthsAgo = new Date(new Date().setMonth(new Date().getMonth() - 6));
      const startMatchesSixMonths = this.selectedDate.start.toDateString() === sixMonthsAgo.toDateString();
      const endMatchesToday = this.selectedDate.end.toDateString() === new Date().toDateString();
      return startMatchesSixMonths && endMatchesToday;
    },
  },
  watch: {
    viewEditOrderDialog() {
      if (!this.viewEditOrderDialog) {
        this.isConfirmingOrder = false;
      }
    },
    selectedDate() {
      if (this.selectedDate !== null) {
        this.start_date = this.selectedDate.start;
        this.end_date = this.selectedDate.end;
        this.calenderKey++;
      } else {
        this.selectedDate = "";
        this.start_date = "";
        this.end_date = "";
        this.calenderKey++;
      }
    },
    filters() {
      if (!this._switchingTab) {
        this.getPaginatedOrders();
      }
    },
    isOrderListUpdateAllowedGetter: function () {
      if (this.isOrderListUpdateAllowedGetter) {
        // Market refresh/an order just happened, so let's update the list
        const selectedItems = Object.assign([], this.purchasesSelected); // Keep a reference of the purchases selected before it's flushed
        this.getPaginatedOrders();
        this.allowUpdateOrderList(false);
        this.purchasesSelected = selectedItems; // Re-assign selected purchases
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.datePicker {
  width: 180px;
}
.el-select {
  ::placeholder {
    font-size: 12px;
  }
}

.el-select-dropdown__item {
  padding: 0px !important;
  padding-left: 10px !important;
}

.order-history-btn-link {
  color: map-get($platform-theme, orderhistory-orderId-link-color) !important;
}
</style>
